import PageBackTitle from "../Component/PageBackTitle";
import React, {
  useState,
  useRef,
  useContext,
  useEffect,
  useCallback,
} from "react";
import "./UserForm.css";
import { useNavigate } from "react-router-dom";
import "../Responsive/TableResponsive.css";
import "../Responsive/FormResponsive.css";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import API_URL from "../../src/Config";
import { FaPlusCircle } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import ReactSelect from "react-select";
import { ThemeContext } from "../../src/ThemeContext";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import "../tables/expense.css";
import Select from "react-select";

// ── Category options ───────────────────────────────────────────────────────────
const expenseCategoryOptions = [
  { value: "IOCL Depot", label: "IOCL Depot" },
  { value: "Keshav Encon", label: "Keshav Encon" },
  { value: "Travel", label: "Travel" },
  { value: "Fuel", label: "Fuel" },
  { value: "Accommodation", label: "Accommodation" },
  { value: "Food", label: "Food" },
  { value: "Miscellaneous", label: "Miscellaneous" },
  { value: "Office Supplies", label: "Office Supplies" },
  { value: "Communication", label: "Communication" },
  { value: "General", label: "General" },
];

const emptyItem = () => ({
  expense_date: null,
  bill_receipt_no: "",
  amount: "",
  purpose_description: "",
  vendor_remark: "",
  expense_category: "General",
});

function ExpenseForm({ isSidebarExpanded }) {
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [users, setUsers] = useState([]);
  const navigate = useNavigate();
  const containerRef = useRef(null);
  const { theme } = useContext(ThemeContext);

  const selectStyles = {
    container: (provided) => ({
      ...provided,
      width: "100%",
      marginTop: "15px !important",
    }),

    control: (provided) => ({
      ...provided,
      backgroundColor: theme === "dark" ? "black" : "white", // Dropdown background color
      color: theme === "dark" ? "#fff" : "#333", // Text color
      borderColor: theme === "dark" ? "#444" : "#ccc", // Border color
      cursor: "pointer",
      boxShadow: "none",
      "&:hover": {
        borderColor: theme === "dark" ? "#666" : "#888", // Border color on hover
      },
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: theme === "dark" ? "#000" : "#fff", // Black background for dropdown menu in dark mode
      border: `1px solid ${theme === "dark" ? "#444" : "#ccc"}`, // Adding a border to the opened menu
      boxShadow:
        theme === "dark"
          ? "0 4px 6px rgba(0, 0, 0, 0.6)"
          : "0 4px 6px rgba(0, 0, 0, 0.1)", // Optional shadow for better separation
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused
        ? "#666" // Gray when hovered
        : theme === "dark"
          ? "#000"
          : "#fff", // Black background for options in dark mode
      color: state.isFocused ? "#fff" : theme === "dark" ? "#fff" : "#333", // Text color
      cursor: "pointer",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme === "dark" ? "#fff" : "#333", // Selected option text color
    }),
  };

  const selectStyles1 = {
    control: (provided) => ({
      ...provided,
      backgroundColor: theme === "dark" ? "black" : "white", // Dropdown background color
      color: theme === "dark" ? "#fff" : "#333", // Text color
      borderColor: theme === "dark" ? "#444" : "#ccc", // Border color
      cursor: "pointer",
      boxShadow: "none",
      "&:hover": {
        borderColor: theme === "dark" ? "#666" : "#888", // Border color on hover
      },
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: theme === "dark" ? "#000" : "#fff", // Black background for dropdown menu in dark mode
      border: `1px solid ${theme === "dark" ? "#444" : "#ccc"}`, // Adding a border to the opened menu
      boxShadow:
        theme === "dark"
          ? "0 4px 6px rgba(0, 0, 0, 0.6)"
          : "0 4px 6px rgba(0, 0, 0, 0.1)", // Optional shadow for better separation
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused
        ? "#666" // Gray when hovered
        : theme === "dark"
          ? "#000"
          : "#fff", // Black background for options in dark mode
      color: state.isFocused ? "#fff" : theme === "dark" ? "#fff" : "#333", // Text color
      cursor: "pointer",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme === "dark" ? "#fff" : "#333", // Selected option text color
    }),
  };

  // ── Fetch users ────────────────────────────────────────────────────────────
  const fetchUsers = useCallback(async () => {
    try {
      const authKey = localStorage.getItem("authKey");
      const res = await axios.get(`${API_URL}/api/get_user`, {
        headers: { Authorization: authKey },
      });
      if (Array.isArray(res.data)) setUsers(res.data);
    } catch (err) {
      console.error("Error fetching users:", err.message);
    }
  }, []);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const [reportData, setReportData] = useState({
    report_month: "",
    location: "",
    advance_amount: "",
    balance_brought_forward: "",
    claim_period_start: null,
    claim_period_end: null,
    user_id: "",
  });

  const [items, setItems] = useState([emptyItem()]);

  const showSnackbar = (message, sev = "success") => {
    setSnackbarMessage(message);
    setSeverity(sev);
    setSnackbarOpen(true);
  };

  const handleReportChange = (field, value) => {
    setReportData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleItemChange = (index, field, value) => {
    setItems((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
    setErrors((prev) => ({ ...prev, [`item_${index}_${field}`]: "" }));
  };

  const handleAddItem = () => setItems((prev) => [...prev, emptyItem()]);
  const handleRemoveItem = (index) =>
    setItems((prev) => prev.filter((_, i) => i !== index));
  const handleCancelClick = () => navigate("/all-expenses");

  const validate = () => {
    const newErrors = {};
    let hasError = false;
    if (!reportData.report_month) {
      newErrors.report_month = "Report month is required";
      hasError = true;
    }
    items.forEach((item, idx) => {
      if (!item.amount || isNaN(parseFloat(item.amount))) {
        newErrors[`item_${idx}_amount`] = "Amount is required";
        hasError = true;
      }
    });
    setErrors(newErrors);
    return !hasError;
  };

  const handleSaveClick = async () => {
    if (!validate()) {
      showSnackbar("Please fix validation errors.", "warning");
      return;
    }
    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");

      const reportPayload = {
        report_month: reportData.report_month,
        location: reportData.location || null,
        advance_amount: parseFloat(reportData.advance_amount) || 0,
        balance_brought_forward:
          parseFloat(reportData.balance_brought_forward) || 0,
        claim_period_start: reportData.claim_period_start
          ? format(reportData.claim_period_start, "yyyy-MM-dd")
          : null,
        claim_period_end: reportData.claim_period_end
          ? format(reportData.claim_period_end, "yyyy-MM-dd")
          : null,
      };
      if (reportData.user_id) reportPayload.user_id = reportData.user_id;

      // Step 1: Create report
      const createRes = await axios.post(
        `${API_URL}/api/expense_report/create`,
        reportPayload,
        {
          headers: {
            Authorization: authKey,
            "Content-Type": "application/json",
          },
        },
      );
      if (createRes.status !== 201)
        throw new Error("Failed to create expense report");

      const reportId = createRes.data.report_id;

      // Step 2: Add all items in a single call
      if (items.length > 0) {
        await axios.post(
          `${API_URL}/api/expense_report/${reportId}/items`,
          {
            items: items.map((item) => ({
              expense_date: item.expense_date
                ? format(item.expense_date, "yyyy-MM-dd")
                : null,
              bill_receipt_no: item.bill_receipt_no || null,
              amount: parseFloat(item.amount),
              purpose_description: item.purpose_description || null,
              vendor_remark: item.vendor_remark || null,
              expense_category: item.expense_category || "General",
            })),
          },
          {
            headers: {
              Authorization: authKey,
              "Content-Type": "application/json",
            },
          },
        );
      }

      showSnackbar("Expense report created successfully");
      setTimeout(() => navigate("/all-expenses"), 1000);
    } catch (error) {
      showSnackbar(
        error.response?.data?.message || "Error saving expense report",
        "error",
      );
    } finally {
      setIsLoading(false);
    }
  };

  const totalAmount = items.reduce(
    (sum, item) => sum + (parseFloat(item.amount) || 0),
    0,
  );

  const userOptions = users.map((u) => ({ value: u.ID, label: u.Name }));

  const formatCurrency = (val) =>
    `₹${parseFloat(val || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

  // ── Render ─────────────────────────────────────────────────────────────────
  return (
    <>
      <div
        className={`data-form-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-form-content" ref={containerRef}>
          <div className="data-form-header">
            <div className="data-form-header-content">
              <PageBackTitle className="data-form-heading-content-left-side">New Expense Report</PageBackTitle>
              <div className="data-form-heading-content-right-side" />
            </div>
          </div>

          <div className="header-separator"></div>

          <div className="data-form-body">
            <form
              className="form-detail"
              onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
            >
              <div className="new-data-form">
                {/* Employee */}
                <div className="form-group-select">
                  <label>Employee</label>
                  <Select
                    options={userOptions}
                    value={
                      userOptions.find((u) => u.value === reportData.user_id) ||
                      null
                    }
                    onChange={(opt) =>
                      handleReportChange("user_id", opt?.value || "")
                    }
                    // styles={selectStyles}
                    placeholder="Select employee..."
                    isClearable
                    styles={selectStyles1}
                  />
                </div>

                {/* Report Month */}
                <div className="form-group">
                  <label>
                    Report Month<span className="text-danger">*</span>
                  </label>
                  <div className="input-group">
                    <input
                      type="month"
                      value={reportData.report_month}
                      onChange={(e) =>
                        handleReportChange("report_month", e.target.value)
                      }
                    />
                  </div>
                  {errors.report_month && (
                    <div className="error-message">{errors.report_month}</div>
                  )}
                </div>

                {/* Location */}
                <div className="form-group">
                  <label>Location / Site</label>
                  <div className="input-group">
                    <input
                      type="text"
                      value={reportData.location}
                      onChange={(e) =>
                        handleReportChange("location", e.target.value)
                      }
                      placeholder="Enter location or site"
                    />
                  </div>
                </div>

                {/* Advance Amount */}
                <div className="form-group">
                  <label>Advance Amount (₹)</label>
                  <div className="input-group">
                    <input
                      type="number"
                      value={reportData.advance_amount}
                      onChange={(e) =>
                        handleReportChange("advance_amount", e.target.value)
                      }
                      placeholder="Enter advance amount"
                      min="0"
                      step="0.01"
                    />
                  </div>
                </div>

                {/* Balance Brought Forward */}
                <div className="form-group">
                  <label>Balance Brought Forward (₹)</label>
                  <div className="input-group">
                    <input
                      type="number"
                      value={reportData.balance_brought_forward}
                      onChange={(e) =>
                        handleReportChange(
                          "balance_brought_forward",
                          e.target.value,
                        )
                      }
                      placeholder="Enter balance brought forward"
                      min="0"
                      step="0.01"
                    />
                  </div>
                </div>

                {/* Claim Period Start */}
                <div className="form-group">
                  <label>Claim Period Start</label>
                  <div className="input-group">
                    <DatePicker
                      selected={reportData.claim_period_start}
                      onChange={(date) =>
                        handleReportChange("claim_period_start", date)
                      }
                      placeholderText="Select start date"
                      className="dates"
                      dateFormat="yyyy-MM-dd"
                      showYearDropdown
                      showMonthDropdown
                      dropdownMode="select"
                    />
                  </div>
                </div>

                {/* Claim Period End */}
                <div className="form-group">
                  <label>Claim Period End</label>
                  <div className="input-group">
                    <DatePicker
                      selected={reportData.claim_period_end}
                      onChange={(date) =>
                        handleReportChange("claim_period_end", date)
                      }
                      placeholderText="Select end date"
                      className="dates"
                      dateFormat="yyyy-MM-dd"
                      showYearDropdown
                      showMonthDropdown
                      dropdownMode="select"
                      minDate={reportData.claim_period_start}
                    />
                  </div>
                </div>
              </div>

              {/* ── Expense Items Section ── */}
              <div className="form-group" style={{ marginTop: "20px" }}>
                <div className="expense_form_section_label">
                  Expense Items<span className="text-danger">*</span>
                </div>

                <div className="new-frequency-rowss">
                  {items.map((item, index) => (
                    <div key={index} className="location-group-content">
                      <div className="location-group margin_left_expenses">
                        {/* Row 1 */}
                        <div
                          className="flex-group"
                          style={{ flexWrap: "wrap", gap: "12px" }}
                        >
                          {/* Date */}
                          <div>
                            <label
                              style={{
                                fontSize: "12px",
                                color: "#555",
                                display: "block",
                                marginBottom: "4px",
                                width: "100%",
                              }}
                            >
                              Date
                            </label>
                            <div className="input-group frequency-row">
                              <DatePicker
                                selected={item.expense_date}
                                onChange={(date) =>
                                  handleItemChange(index, "expense_date", date)
                                }
                                placeholderText="Select date"
                                className="dates point-fr"
                                dateFormat="yyyy-MM-dd"
                                showYearDropdown
                                showMonthDropdown
                                dropdownMode="select"
                              />
                            </div>
                          </div>

                          {/* Bill No */}
                          <div>
                            <label
                              style={{
                                fontSize: "12px",
                                color: "#555",
                                display: "block",
                                marginBottom: "4px",
                                width: "100%",
                              }}
                            >
                              Bill / Receipt No
                            </label>
                            <div className="input-group frequency-row">
                              <input
                                type="text"
                                className="point-fr"
                                value={item.bill_receipt_no}
                                onChange={(e) =>
                                  handleItemChange(
                                    index,
                                    "bill_receipt_no",
                                    e.target.value,
                                  )
                                }
                                placeholder="Bill / Receipt No"
                              />
                            </div>
                          </div>

                          {/* Amount */}
                          <div>
                            <label
                              style={{
                                fontSize: "12px",
                                color: "#555",
                                display: "block",
                                marginBottom: "4px",
                                width: "100%",
                              }}
                            >
                              Amount (₹)<span className="text-danger">*</span>
                            </label>
                            <div className="input-group frequency-row">
                              <input
                                type="number"
                                className="point-fr"
                                value={item.amount}
                                onChange={(e) =>
                                  handleItemChange(
                                    index,
                                    "amount",
                                    e.target.value,
                                  )
                                }
                                placeholder="₹ 0.00"
                                min="0"
                                step="0.01"
                              />
                            </div>
                            {errors[`item_${index}_amount`] && (
                              <div className="error-message">
                                {errors[`item_${index}_amount`]}
                              </div>
                            )}
                          </div>

                          {/* Category */}
                          <div className="" style={{ width: "48%" }}>
                            <label
                              style={{
                                fontSize: "12px",
                                color: "#555",
                                display: "block",
                                marginBottom: "4px",
                                width: "100%",
                              }}
                            >
                              Expense Type
                            </label>
                            <div className="">
                              <Select
                                options={expenseCategoryOptions}
                                value={
                                  expenseCategoryOptions.find(
                                    (o) => o.value === item.expense_category,
                                  ) || null
                                }
                                onChange={(opt) =>
                                  handleItemChange(
                                    index,
                                    "expense_category",
                                    opt?.value || "General",
                                  )
                                }
                                styles={selectStyles}
                                placeholder="Select type..."
                              />
                            </div>
                          </div>
                        </div>

                        {/* Row 2 */}
                        <div
                          className="flex-group"
                          style={{ marginTop: "10px", gap: "12px" }}
                        >
                          <div style={{ flex: 1 }}>
                            <label
                              style={{
                                fontSize: "12px",
                                color: "#555",
                                display: "block",
                                marginBottom: "4px",
                                width: "100%",
                              }}
                            >
                              Purpose / Description
                            </label>
                            <div className="input-group frequency-row">
                              <textarea
                                className="point-fr"
                                value={item.purpose_description}
                                onChange={(e) =>
                                  handleItemChange(
                                    index,
                                    "purpose_description",
                                    e.target.value,
                                  )
                                }
                                placeholder="Enter purpose or description"
                                rows="2"
                                cols="30"
                              />
                            </div>
                          </div>
                          <div style={{ flex: 1 }}>
                            <label
                              style={{
                                fontSize: "12px",
                                color: "#555",
                                display: "block",
                                marginBottom: "4px",
                                width: "100%",
                              }}
                            >
                              Vendor / Remark
                            </label>
                            <div className="input-group frequency-row">
                              <textarea
                                className="point-fr"
                                value={item.vendor_remark}
                                onChange={(e) =>
                                  handleItemChange(
                                    index,
                                    "vendor_remark",
                                    e.target.value,
                                  )
                                }
                                placeholder="Enter vendor or remark"
                                rows="2"
                                cols="30"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Remove */}
                      <div>
                        <button
                          type="button"
                          className="add-close-button"
                          onClick={() => handleRemoveItem(index)}
                          disabled={items.length === 1}
                        >
                          <IoClose className="frequency-close-icon" />
                        </button>
                      </div>
                    </div>
                  ))}

                  <div className="expenses_dflex_total">
                    {/* Total */}
                    {items.length > 0 && (
                      <div className="expense_items_total">
                        Total: {formatCurrency(totalAmount)}
                      </div>
                    )}

                    {/* Add item */}
                    <div className="add-new-frequency-customer">
                      <button
                        className="add-new-buttons"
                        type="button"
                        onClick={handleAddItem}
                      >
                        <FaPlusCircle className="frequency-plus-icon" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div className="footer">
            <div className="button-group">
              <button
                className="data-form-save-button"
                type="button"
                onClick={handleSaveClick}
                disabled={isLoading}
              >
                {isLoading ? "Saving..." : "Save"}
              </button>
              <button
                className="data-form-cancel-button"
                onClick={handleCancelClick}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px", marginLeft: "20px" }}
      >
        <MuiAlert onClose={() => setSnackbarOpen(false)} severity={severity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default ExpenseForm;
